import React from 'react';
import moment from 'moment';

const getDate = (value) => {
    const date = new Date(moment.utc(+value));
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const month = (+date.getMonth() + 1) < 10? '0' + (+date.getMonth() + 1) : date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();

    return <span>{hours + ':' + min} {day + '/' + month + '/' + year}</span>
}

const getDateForm = (value) => {
    const date = new Date(moment.utc(+value));
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const month = +date.getMonth() + 1 < 10? '0' + (+date.getMonth() + 1) : date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    
    return `${year}-${month}-${day}T${hours}:${min}`
}


const getDateFormManually = (value) => {
    const date = new Date(moment.utc(+value));
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const month = +date.getMonth() + 1 < 10? '0' + (+date.getMonth() + 1) : date.getMonth() + 1;
    const year = date.getFullYear();
    
    return `${year}-${month}-${day}`
}

export {
    getDate,
    getDateForm,
    getDateFormManually
}